// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-34_aH","loading":"index-loading-2OFZY","closeButton":"index-closeButton-28lbf","qrWrapper":"index-qrWrapper-1VGXL"};